export default "__VITE_PUBLIC_ASSET__1000a7dc__"